import { Directive, HostListener, inject } from '@angular/core';
import {NavigationService} from '../services/navigation.service';

@Directive({
    selector: '[appNavigateBack]',
    standalone: false
})
export class NavigateBackDirective {
    private navigationService = inject(NavigationService);


    @HostListener('click')
    onClick(): void {
        this.navigationService.back();
    }
}
